export default function assignPriceSpecification(basicEntity: any, paymentDueBlob: any) {
    return basicEntity && paymentDueBlob
        ? {
              ...basicEntity,
              ...{
                  price: paymentDueBlob.price,
                  priceCurrency: paymentDueBlob.priceCurrency,
              },
          }
        : null;
}
